import React from "react";
import { Property } from "../../BuildingProductEditor/ProductEditorStore";
import clsx from "clsx";
import { PropertyTypeChoices } from "api-client";
import PropertyIcon from "features/PropertyManager/components/PropertyIcon";
import SelectedItem from "features/PropertyManager/components/SelectedItem";
import { useTranslation } from "react-i18next";

const PropertyRow = ({
  property,
  ...props
}: {
  property: Property;
  index: number;
}) => {
  const { t } = useTranslation();

  function propertyValue() {
    if (
      (!property.value &&
        property.property_type !== PropertyTypeChoices.Boolean) ||
      (property.property_type === PropertyTypeChoices.Multiselect &&
        !(property.value as string[])?.length)
    ) {
      return (
        <span className="text-sm text-gray-400 font-normal">
          {t("productEditor.notDefined")}
        </span>
      );
    }

    return (
      <>
        {(property.property_type === PropertyTypeChoices.Text ||
          property.property_type === PropertyTypeChoices.Number) && (
          <span className="break-all text-sm text-gray-600 font-normal">
            {property.property_type === PropertyTypeChoices.Number
              ? String(property.value).replace(".", ",")
              : property.value}
          </span>
        )}
        {property.property_type === PropertyTypeChoices.Boolean && (
          <span className="text-sm text-gray-600 font-normal">
            {property.value ? t("commons.yes") : t("commons.no")}
          </span>
        )}
        {property.property_type === PropertyTypeChoices.Multiselect && (
          <div className="flex flex-wrap items-center h-full py-1.5 gap-1">
            {property.value &&
              (property.value as string[])?.map((rec, index) => (
                <SelectedItem key={index} rec={rec} />
              ))}
          </div>
        )}
        {property.property_type === PropertyTypeChoices.Select && (
          <div className="flex flex-wrap items-center h-full py-1">
            {property.value && <SelectedItem rec={property.value as string} />}
          </div>
        )}
      </>
    );
  }

  return (
    <div
      className="flex border-t border-gray-300 first-of-type:border-t-0 relative"
      key={props.index}
    >
      <div className="flex flex-1 h-full items-center">
        <div
          className={clsx(
            "min-w-6 min-h-4 h-full px-2 py-2 border-r border-gray-100 group/property relative text-gray-500",
            "flex items-center"
          )}
        >
          <PropertyIcon name={property.property_type} size={20} />
        </div>
        <div className="min-h-full flex items-center px-2 break-all">
          {property.name}
        </div>
      </div>
      <div
        className={clsx(
          "items-center border-l border-gray-100 text-gray-900 w-full px-2",
          "flex flex-1 items-center min-h-full justify-between"
        )}
      >
        {propertyValue()}
      </div>
    </div>
  );
};

export default PropertyRow;
